import React from 'react';
import { LoadingSpinner } from './loading-spinner';

interface LoadingProps {
  text: string;
}

const Loading: React.FC<LoadingProps> = ({ text }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75">
      <LoadingSection text={text} />
    </div>
  );
};

export const LoadingSection = ({ text }: LoadingProps) => {
  return (
    <div className="flex flex-col items-center">
      <LoadingSpinner />

      <p className="text-gray-600">{text}</p>
    </div>
  );
};

export default Loading;
